import React from 'react';
import babyOne from '../../../assets/images/resources_screen/baby_one.jpg';

const MatSuValley = () => {
  return (
    <div className="w-full flex flex-col md:flex-row gap-4 items-end sm:gap-10 md:gap-24 max-w-[1238px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div className="flex-1">
        <img src={babyOne} alt="babyOne" />
      </div>
      <div className="flex-1 flex flex-col gap-4">
        <h2 className="text-[28px] sm:text-[34px] text-primary font-bold leading-tight">
          Guidepost Pediatric OT/PT <br />
          Resources for the Mat-Su Valley
        </h2>
        <p className="text-secondary text-lg 2xl:text-2xl">
          At our Pediatric OT/PT Center in Wasilla, Alaska, we are committed to
          providing comprehensive support for your child's developmental needs.
          Here, you will find a curated selection of resources tailored to
          assist families in understanding and enhancing therapy in
          occupational, physical, and speech domains. Our aim is to equip you
          with the information and tools necessary to foster your child's
          progress. Educational materials, practical strategies and links/videos
          to reputable research and articles in the field of pediatric therapy.
        </p>
      </div>
    </div>
  );
};

export default MatSuValley;
